import { render, staticRenderFns } from "./order_underway.vue?vue&type=template&id=37652e59&scoped=true"
import script from "./order_underway.vue?vue&type=script&lang=js"
export * from "./order_underway.vue?vue&type=script&lang=js"
import style0 from "./order_underway.vue?vue&type=style&index=0&id=37652e59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37652e59",
  null
  
)

export default component.exports